import React from "react"
import "./animation.css"

const HomeIllustration = () => {
  return (
    <svg viewBox="0 0 1177 801" fill="none">
      <g filter="url(#prefix__filter0_i)">
        <ellipse
          cx={1092.96}
          cy={245.664}
          rx={84.084}
          ry={34.379}
          fill="#E2E8F0"
        />
      </g>
      <path
        d="M1165.44 243.178c0 16.242-32.45 29.409-72.48 29.409s-72.49-13.167-72.49-29.409c0-16.242 32.46-29.409 72.49-29.409 40.03 0 72.48 13.167 72.48 29.409z"
        fill="#CBD5E0"
      />
      <path
        d="M1020.47 181.461h144.97v62.131h-144.97v-62.131z"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter1_f)">
        <path
          d="M1072.63 259.687c-28.29 0-37.76-45.74-43.24-63.413 24.46 13.452 53.81 18.344 89.89 12.229-3.81 17.673-18.36 51.184-46.65 51.184z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter2_d)">
        <ellipse
          cx={1092.96}
          cy={181.047}
          rx={72.486}
          ry={29.409}
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter3_i)">
        <ellipse
          cx={1092.96}
          cy={181.047}
          rx={51.776}
          ry={21.125}
          fill="#CBD5E0"
        />
      </g>
      <g filter="url(#prefix__filter4_i)">
        <ellipse
          cx={1092.98}
          cy={180.988}
          rx={64.813}
          ry={25.681}
          fill="#B1CE7B"
        />
      </g>
      <g filter="url(#prefix__filter5_i)">
        <ellipse
          cx={1092.99}
          cy={180.988}
          rx={51.973}
          ry={20.789}
          fill="#95BF46"
        />
      </g>

      <g filter="url(#prefix__filter6_i)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1092.97 163.263a126.352 126.352 0 012.48 0c.34.004.61.281.6.619 0 .337-.28.608-.61.604a126.082 126.082 0 00-2.46 0 .615.615 0 01-.62-.604c0-.338.27-.615.61-.619zm-1.85.647c.01.337-.25.62-.59.632-.82.028-1.63.065-2.44.112a.614.614 0 01-.65-.575.614.614 0 01.58-.646c.81-.047 1.64-.085 2.47-.113.34-.012.62.252.63.59zm6.17 0c.01-.338.3-.602.63-.59.84.028 1.66.066 2.48.113.34.02.59.309.57.646a.611.611 0 01-.64.575c-.81-.047-1.63-.084-2.45-.112a.618.618 0 01-.59-.632zm4.92.255a.611.611 0 01.66-.56c.83.068 1.65.145 2.47.232a.61.61 0 01-.13 1.216c-.81-.085-1.62-.162-2.44-.229a.608.608 0 01-.56-.659zm-16 0a.622.622 0 01-.56.659c-.82.067-1.64.144-2.44.229a.603.603 0 01-.67-.543.603.603 0 01.54-.673c.81-.087 1.64-.164 2.47-.232.33-.028.63.223.66.56zm-4.91.493a.606.606 0 01-.52.686c-.82.109-1.63.228-2.42.355a.605.605 0 01-.7-.506.605.605 0 01.5-.701c.81-.13 1.63-.25 2.46-.36.33-.044.64.191.68.526zm25.81 0c.05-.335.35-.57.69-.526.83.11 1.65.23 2.45.36a.612.612 0 11-.19 1.207c-.8-.127-1.6-.246-2.42-.355a.614.614 0 01-.53-.686zm4.87.748a.605.605 0 01.71-.486c.83.157 1.64.324 2.43.501a.61.61 0 11-.26 1.194c-.78-.174-1.58-.339-2.4-.494a.603.603 0 01-.48-.715zm-35.54 0a.617.617 0 01-.49.715c-.81.155-1.61.32-2.39.494a.61.61 0 01-.73-.464.605.605 0 01.46-.73c.8-.177 1.61-.344 2.43-.501a.62.62 0 01.72.486zm40.36 1.035a.602.602 0 01.74-.439c.82.21 1.61.431 2.39.663.32.097.51.437.41.761a.605.605 0 01-.76.411c-.76-.227-1.54-.444-2.34-.651a.606.606 0 01-.44-.745zm-45.18 0c.08.327-.11.66-.44.745-.8.207-1.58.424-2.35.651a.614.614 0 01-.76-.411.62.62 0 01.41-.761c.78-.232 1.58-.453 2.39-.663.33-.085.66.112.75.439zm49.91 1.364a.614.614 0 01.78-.379c.8.276 1.58.564 2.33.863.31.125.46.481.34.795a.617.617 0 01-.8.342c-.73-.292-1.49-.573-2.27-.844a.61.61 0 01-.38-.777zm-54.64 0a.61.61 0 01-.38.777c-.79.271-1.55.552-2.28.844a.606.606 0 01-.79-.342.602.602 0 01.34-.795c.75-.299 1.53-.587 2.33-.863.32-.11.67.06.78.379zm-4.6 1.77c.14.307.01.67-.29.813-.76.352-1.48.717-2.16 1.092a.609.609 0 01-.83-.24.602.602 0 01.24-.831c.7-.39 1.45-.767 2.23-1.13.31-.143.67-.01.81.296zm63.83 0a.62.62 0 01.82-.296c.78.363 1.52.74 2.23 1.13.29.163.4.535.24.831a.611.611 0 01-.83.24c-.68-.375-1.4-.74-2.16-1.092a.612.612 0 01-.3-.813zm-68.17 2.305a.62.62 0 01-.17.848c-.7.467-1.34.946-1.91 1.436a.621.621 0 01-.87-.07.617.617 0 01.07-.862c.62-.523 1.3-1.03 2.03-1.52a.614.614 0 01.85.168zm72.52 0a.614.614 0 01.85-.168c.73.49 1.4.997 2.02 1.52.26.219.29.604.07.862a.61.61 0 01-.86.07c-.58-.49-1.22-.969-1.91-1.436a.61.61 0 01-.17-.848zm-76.36 3.083c.26.219.29.606.07.862-.54.626-.98 1.263-1.32 1.907a.603.603 0 01-.82.257.61.61 0 01-.26-.826c.39-.736.88-1.448 1.47-2.135a.61.61 0 01.86-.065zm80.19 0c.26-.22.64-.191.86.065.59.687 1.09 1.399 1.47 2.135.16.299.05.668-.25.826a.617.617 0 01-.83-.257c-.34-.644-.78-1.281-1.31-1.907a.616.616 0 01.06-.862zm2.49 4.198a.61.61 0 01.71.496 7.412 7.412 0 010 2.663.61.61 0 11-1.2-.213c.06-.37.1-.743.1-1.119 0-.375-.04-.748-.1-1.118a.609.609 0 01.49-.709zm-85.17 0c.33.059.56.376.5.709-.07.37-.1.743-.1 1.118 0 .376.03.749.1 1.119a.615.615 0 01-1.21.213 7.431 7.431 0 010-2.663.616.616 0 01.71-.496zm84.76 4.827c.3.157.41.527.25.826-.38.735-.88 1.448-1.47 2.134a.608.608 0 01-.86.066.616.616 0 01-.06-.862c.53-.626.97-1.263 1.31-1.907a.617.617 0 01.83-.257zm-84.34 0c.3-.157.67-.042.82.257.34.644.78 1.281 1.32 1.907.22.256.19.642-.07.862a.609.609 0 01-.86-.066 11.658 11.658 0 01-1.47-2.134.61.61 0 01.26-.826zm2.96 3.895a.621.621 0 01.87-.071c.57.491 1.21.97 1.91 1.436a.62.62 0 01.17.849.615.615 0 01-.85.168c-.73-.49-1.41-.997-2.03-1.52a.617.617 0 01-.07-.862zm78.41 0c.22.257.19.643-.07.862-.62.523-1.29 1.03-2.02 1.52a.611.611 0 11-.68-1.017c.69-.466 1.33-.945 1.91-1.436a.61.61 0 01.86.071zm-74.4 2.854a.609.609 0 01.83-.241c.68.376 1.4.74 2.16 1.093.3.142.43.506.29.812a.608.608 0 01-.81.297 35.1 35.1 0 01-2.23-1.131.601.601 0 01-.24-.83zm70.4 0c.16.295.05.667-.24.83-.71.39-1.45.767-2.23 1.131a.622.622 0 01-.82-.297.611.611 0 01.3-.812c.76-.353 1.48-.717 2.16-1.093a.611.611 0 01.83.241zm-65.97 2.156a.606.606 0 01.79-.342c.73.292 1.49.573 2.28.843a.611.611 0 11-.4 1.157c-.8-.277-1.58-.565-2.33-.864a.601.601 0 01-.34-.794zm61.54 0a.618.618 0 01-.34.794c-.75.299-1.53.587-2.33.864a.611.611 0 11-.4-1.157c.78-.27 1.54-.551 2.27-.843.32-.125.67.028.8.342zm-4.64 1.658c.1.323-.09.664-.41.761a66.3 66.3 0 01-2.39.663.603.603 0 01-.74-.439.605.605 0 01.44-.745c.8-.207 1.58-.424 2.34-.651.33-.097.67.087.76.411zm-52.27 0c.1-.324.44-.508.76-.411.77.227 1.55.444 2.35.651.33.084.52.418.44.745a.618.618 0 01-.75.439c-.81-.21-1.61-.432-2.39-.663a.62.62 0 01-.41-.761zm4.76 1.274a.61.61 0 01.73-.464c.78.175 1.58.34 2.39.494.33.064.55.384.49.715a.621.621 0 01-.72.487c-.82-.157-1.63-.325-2.43-.502a.604.604 0 01-.46-.73zm42.76 0c.07.33-.14.657-.47.73-.79.177-1.6.345-2.43.502a.606.606 0 01-.71-.487.604.604 0 01.48-.715c.82-.154 1.62-.319 2.4-.494a.61.61 0 01.73.464zm-37.93.959c.05-.334.36-.56.7-.507.79.128 1.6.246 2.42.355.33.045.57.352.52.687a.604.604 0 01-.68.525c-.83-.11-1.65-.23-2.46-.359a.605.605 0 01-.5-.701zm33.1 0a.612.612 0 01-.51.701c-.8.129-1.62.249-2.45.359a.614.614 0 01-.69-.525.615.615 0 01.53-.687 91.89 91.89 0 002.42-.355.61.61 0 01.7.507zm-28.22.682a.603.603 0 01.67-.543c.8.086 1.62.163 2.44.23.33.027.58.323.56.659a.618.618 0 01-.66.56c-.83-.068-1.66-.146-2.47-.233a.603.603 0 01-.54-.673zm23.34 0a.61.61 0 01-.54.673c-.82.087-1.64.165-2.47.233a.612.612 0 11-.1-1.219c.82-.067 1.63-.144 2.44-.23.33-.036.63.208.67.543zm-18.44.432a.614.614 0 01.65-.575c.81.046 1.62.084 2.44.112.34.011.6.294.59.632a.608.608 0 01-.63.59c-.83-.028-1.66-.066-2.47-.113a.614.614 0 01-.58-.646zm13.53 0a.606.606 0 01-.57.646c-.82.047-1.64.085-2.48.113a.614.614 0 01-.63-.59.617.617 0 01.59-.632c.82-.028 1.64-.066 2.45-.112a.61.61 0 01.64.575zm-8.61.197a.616.616 0 01.62-.605 100.866 100.866 0 002.46 0c.33-.003.61.267.61.605a.602.602 0 01-.6.618 102.513 102.513 0 01-2.48 0 .617.617 0 01-.61-.618z"
          fill="#5E8E3E"
        />
      </g>
      <g filter="url(#prefix__filter7_i)">
        <ellipse
          cx={1092.99}
          cy={180.988}
          rx={21.401}
          ry={8.56}
          fill="#709B1E"
        />
      </g>

      <path
        className="shopify-station-light"
        d="M1144.96 0v180.988l-3.06 6.726-18.34 7.949s-7.95 4.892-26.3 5.503c-21.41.714-53.19-13.452-53.19-13.452l-3.05-6.726V0h103.94z"
        fill="url(#prefix__paint0_linear)"
      />
      <g className="shopify-logo" clipPath="url(#prefix__clip0)">
        <path
          d="M1114.9 95.622c-.04-.349-.35-.542-.6-.563-.25-.02-5.59-.416-5.59-.416l-4.11-4.082c-.4-.406-1.2-.283-1.5-.192-.05.013-.81.25-2.08.64-1.23-3.558-3.42-6.828-7.26-6.828-.1 0-.21.004-.32.01-1.1-1.444-2.45-2.071-3.62-2.071-8.94 0-13.22 11.18-14.56 16.861a2268.77 2268.77 0 00-6.26 1.942c-1.94.608-2 .67-2.26 2.497-.19 1.384-5.27 40.636-5.27 40.636l39.57 7.41 21.44-4.636s-7.53-50.86-7.58-51.208zm-16.06-3.937l-3.35 1.036v-.722c0-2.211-.31-3.992-.8-5.403 1.98.248 3.3 2.499 4.15 5.089zm-6.6-4.65c.55 1.377.9 3.355.9 6.024v.387l-6.91 2.14c1.33-5.135 3.82-7.616 6.01-8.552zm-2.66-2.516c.38 0 .77.13 1.14.387-2.86 1.349-5.94 4.746-7.23 11.53l-5.47 1.691c1.52-5.174 5.13-13.608 11.56-13.608z"
          fill="#95BF46"
        />
        <path
          d="M1114.3 95.06c-.25-.022-5.59-.417-5.59-.417l-4.11-4.082c-.15-.151-.35-.229-.57-.262l-2.99 61.167 21.44-4.636s-7.53-50.86-7.58-51.208c-.04-.349-.35-.542-.6-.563z"
          fill="#5E8E3E"
        />
        <path
          d="M1093.76 106.9l-2.64 7.86s-2.32-1.236-5.16-1.236c-4.16 0-4.37 2.611-4.37 3.269 0 3.59 9.36 4.965 9.36 13.374 0 6.615-4.2 10.875-9.86 10.875-6.79 0-10.26-4.225-10.26-4.225l1.82-6.006s3.57 3.064 6.58 3.064c1.97 0 2.77-1.55 2.77-2.682 0-4.682-7.68-4.891-7.68-12.586 0-6.476 4.65-12.743 14.04-12.743 3.61 0 5.4 1.036 5.4 1.036z"
          fill="#fff"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M534.32 275.299l-2.677-1.532.607-1.062 2.677 1.532-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.354 3.065-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.708 6.128l-5.354-3.064.607-1.061 5.354 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.129l-5.353-3.064.607-1.062 5.354 3.064-.608 1.062zm10.708 6.128l-5.354-3.064.607-1.062 5.354 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.353-3.064.607-1.062 5.354 3.065-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.708 6.128l-5.354-3.064.607-1.061 5.354 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.129l-5.353-3.064.607-1.062 5.354 3.064-.608 1.062zm10.708 6.128l-5.354-3.064.607-1.062 5.354 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.353-3.064.607-1.062 5.354 3.064-.608 1.062zm10.705 6.128l-5.35-3.064.61-1.062 5.35 3.064-.61 1.062zm8.03 4.596l-2.67-1.532.6-1.062 2.68 1.533-.61 1.061z"
        fill="url(#prefix__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M498.248 299.01a6.114 6.114 0 018.348-2.257l443.91 254.973a6.115 6.115 0 01-6.091 10.604l-443.91-254.973a6.114 6.114 0 01-2.257-8.347z"
        fill="url(#prefix__paint2_linear)"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M423.175 301.552l-2.677-1.532.608-1.062 2.677 1.533-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.708 6.128L460.65 323l.607-1.061 5.354 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.129l-5.353-3.065.607-1.061 5.354 3.064-.608 1.062zm10.708 6.128l-5.354-3.064.607-1.062 5.354 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.353-3.064.607-1.062 5.354 3.065-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.708 6.128l-5.354-3.064.607-1.061 5.354 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.354-3.064.608-1.061 5.353 3.064-.607 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.129l-5.353-3.064.607-1.062 5.354 3.064-.608 1.062zm10.708 6.128l-5.354-3.064.607-1.062 5.354 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.354-3.064.608-1.062 5.353 3.064-.607 1.062zm10.707 6.128l-5.353-3.064.607-1.062 5.354 3.064-.608 1.062zm10.707 6.128l-5.353-3.064.607-1.062 5.354 3.064-.608 1.062zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.707 6.128l-5.353-3.064.607-1.061 5.354 3.064-.608 1.061zm10.708 6.128l-5.354-3.064.607-1.061 5.354 3.064-.607 1.061zm8.03 4.596l-2.677-1.532.607-1.061 2.678 1.532-.608 1.061z"
        fill="url(#prefix__paint3_linear)"
      />

      <g filter="url(#prefix__filter8_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1090.04 274.996c-2.76 0-5-.242-5-.54v-24.92c0-.299 2.24-.54 5-.54s5 .241 5 .54v24.92c0 .298-2.24.54-5 .54z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter9_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1026.04 255.996c-2.76 0-5-.233-5-.52v-23.961c0-.287 2.24-.519 5-.519s5 .232 5 .519v23.961c0 .287-2.24.52-5 .52z"
          fill="#A0AEC0"
        />
      </g>

      <ellipse
        cx={1020.61}
        cy={244.401}
        rx={9.172}
        ry={11.617}
        fill="#EDF2F7"
      />

      <ellipse
        cx={1018.16}
        cy={245.624}
        rx={9.172}
        ry={11.617}
        fill="#A0AEC0"
      />
      <g filter="url(#prefix__filter10_di)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M688.76 426.985a7.948 7.948 0 013.124-10.798l321.276-177.12a7.949 7.949 0 0110.8 3.123 7.951 7.951 0 01-3.12 10.799l-321.281 177.12a7.95 7.95 0 01-10.799-3.124z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter11_i)">
        <circle cx={951.514} cy={281.699} r={7.337} fill="#5A67D8" />
      </g>
      <g filter="url(#prefix__filter12_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1014.67 249.406L700.356 422.688l-.591-1.071 314.315-173.282.59 1.071z"
          fill="#fff"
        />
      </g>

      <g filter="url(#prefix__filter15_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1079.15 267.51L764.833 440.793l-.59-1.071L1078.56 266.44l.59 1.07z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter16_i)">
        <ellipse
          cx={709.877}
          cy={435.961}
          rx={124.124}
          ry={50.75}
          fill="#E2E8F0"
        />
      </g>
      <g className="pipe-two">
        <ellipse
          cx={1085.42}
          cy={262.744}
          rx={9.172}
          ry={11.617}
          fill="#EDF2F7"
        />

        <ellipse
          cx={1082.97}
          cy={263.967}
          rx={9.172}
          ry={11.617}
          fill="#A0AEC0"
        />
        <g filter="url(#prefix__filter13_di)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M753.238 445.09a7.949 7.949 0 013.123-10.798l321.279-177.12a7.949 7.949 0 0110.8 3.123 7.951 7.951 0 01-3.12 10.799l-321.283 177.12a7.95 7.95 0 01-10.799-3.124z"
            fill="#F7FAFC"
          />
        </g>
        <g opacity={0.5} filter="url(#prefix__filter14_i)">
          <circle cx={881.539} cy={374.639} r={7.337} fill="#95BF46" />
        </g>
      </g>
      <path
        d="M816.88 432.293c0 23.976-47.907 43.413-107.003 43.413-59.096 0-107.003-19.437-107.003-43.413 0-23.976 47.907-43.413 107.003-43.413 59.096 0 107.003 19.437 107.003 43.413z"
        fill="#CBD5E0"
      />
      <path
        d="M602.874 341.187H816.88v91.717H602.874v-91.717z"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter17_f)">
        <path
          d="M672.028 434.312c-41.767 0-54.901-57.304-62.986-79.316 24.5 24.5 84.062 42.174 130.5 27.5-5.618 22.012-25.748 51.816-67.514 51.816z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter18_d)">
        <path
          d="M816.881 340.576c0 23.976-47.907 43.413-107.003 43.413-59.097 0-107.004-19.437-107.004-43.413 0-23.976 47.907-43.413 107.004-43.413 59.096 0 107.003 19.437 107.003 43.413z"
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter19_di)">
        <ellipse cx={710.042} cy={340.496} rx={97} ry={39.5} fill="#4C51BF" />
        <path
          d="M806.542 340.496c0 5.275-2.623 10.349-7.469 15.015-4.848 4.667-11.888 8.893-20.63 12.452-17.48 7.118-41.663 11.533-68.401 11.533-26.737 0-50.92-4.415-68.4-11.533-8.742-3.559-15.782-7.785-20.63-12.452-4.846-4.666-7.47-9.74-7.47-15.015 0-5.276 2.624-10.35 7.47-15.015 4.848-4.667 11.888-8.893 20.63-12.453 17.48-7.118 41.663-11.532 68.4-11.532 26.738 0 50.921 4.414 68.401 11.532 8.742 3.56 15.782 7.786 20.63 12.453 4.846 4.665 7.469 9.739 7.469 15.015z"
          stroke="#4C51BF"
        />
      </g>
      <g filter="url(#prefix__filter20_di)">
        <ellipse
          cx={709.878}
          cy={340.576}
          rx={76.431}
          ry={31.184}
          fill="#5A67D8"
        />
        <path
          d="M785.808 340.576c0 4.127-2.048 8.107-5.853 11.778-3.807 3.672-9.342 7.002-16.222 9.809-13.757 5.613-32.798 9.097-53.856 9.097-21.057 0-40.098-3.484-53.855-9.097-6.881-2.807-12.415-6.137-16.222-9.809-3.805-3.671-5.853-7.651-5.853-11.778 0-4.128 2.048-8.108 5.853-11.778 3.807-3.672 9.341-7.002 16.222-9.809 13.757-5.614 32.798-9.097 53.855-9.097 21.058 0 40.099 3.483 53.856 9.097 6.88 2.807 12.415 6.137 16.222 9.809 3.805 3.67 5.853 7.65 5.853 11.778z"
          stroke="#4C51BF"
        />
      </g>
      <g filter="url(#prefix__filter21_i)">
        <ellipse
          cx={709.878}
          cy={340.576}
          rx={31.184}
          ry={12.84}
          fill="#4C51BF"
        />
      </g>
      <path
        d="M740.561 340.576c0 1.596-.783 3.164-2.299 4.64-1.517 1.477-3.739 2.83-6.525 3.977-5.569 2.293-13.297 3.723-21.859 3.723-8.563 0-16.291-1.43-21.86-3.723-2.786-1.147-5.008-2.5-6.525-3.977-1.516-1.476-2.299-3.044-2.299-4.64 0-1.597.783-3.165 2.299-4.64 1.517-1.477 3.739-2.83 6.525-3.977 5.569-2.294 13.297-3.724 21.86-3.724 8.562 0 16.29 1.43 21.859 3.724 2.786 1.147 5.008 2.5 6.525 3.977 1.516 1.475 2.299 3.043 2.299 4.64z"
        stroke="#4C51BF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M708.623 315.515a140.99 140.99 0 013.192 0 .413.413 0 01.406.422.413.413 0 01-.414.413 167.617 167.617 0 00-3.176 0 .413.413 0 01-.414-.413.413.413 0 01.406-.422zm5.952.471a.414.414 0 01.423-.405c1.068.034 2.129.079 3.181.135.226.012.4.208.388.439a.413.413 0 01-.431.395c-1.046-.055-2.101-.1-3.163-.133a.416.416 0 01-.398-.431zm-8.712 0a.416.416 0 01-.398.431c-1.062.033-2.117.078-3.163.133a.413.413 0 01-.431-.395.414.414 0 01.388-.439c1.052-.056 2.113-.101 3.181-.135a.414.414 0 01.423.405zm15.053.319a.414.414 0 01.44-.386c1.067.08 2.125.171 3.172.273a.417.417 0 01.369.456.413.413 0 01-.448.376 147.452 147.452 0 00-3.153-.272.416.416 0 01-.38-.447zm-21.394 0a.416.416 0 01-.38.447c-1.061.08-2.112.171-3.153.272a.413.413 0 01-.448-.376.417.417 0 01.369-.456c1.047-.102 2.105-.193 3.172-.273a.414.414 0 01.44.386zm27.715.599a.412.412 0 01.456-.365c1.064.129 2.116.27 3.155.422.225.032.38.244.348.472a.412.412 0 01-.464.355 127.804 127.804 0 00-3.136-.419.417.417 0 01-.359-.465zm-34.036 0a.417.417 0 01-.359.465c-1.057.128-2.103.268-3.136.419a.412.412 0 01-.464-.355.415.415 0 01.348-.472c1.039-.152 2.091-.293 3.155-.422a.412.412 0 01.456.365zm40.319.899a.41.41 0 01.473-.342c1.061.182 2.108.377 3.137.583a.418.418 0 01.324.491.411.411 0 01-.482.329 118.412 118.412 0 00-3.116-.579.418.418 0 01-.336-.482zm-46.602 0a.418.418 0 01-.336.482c-1.054.181-2.093.375-3.116.579a.411.411 0 01-.482-.329.418.418 0 01.324-.491 115.26 115.26 0 013.137-.583.41.41 0 01.473.342zm52.842 1.228a.412.412 0 01.491-.316c1.052.243 2.085.498 3.097.765.22.057.352.285.295.509a.411.411 0 01-.5.3 98.019 98.019 0 00-3.074-.758.418.418 0 01-.309-.5zm-59.082 0a.418.418 0 01-.309.5c-1.045.24-2.07.493-3.074.758a.411.411 0 01-.5-.3.417.417 0 01.295-.509c1.012-.267 2.045-.522 3.097-.765a.412.412 0 01.491.316zm-6.147 1.595a.419.419 0 01-.278.519c-1.031.31-2.037.632-3.016.967a.408.408 0 01-.519-.263.418.418 0 01.258-.529 83.872 83.872 0 013.045-.977.41.41 0 01.51.283zm71.376 0a.41.41 0 01.51-.283c1.041.313 2.056.638 3.045.977.215.073.331.31.258.529a.408.408 0 01-.519.263 84.262 84.262 0 00-3.016-.967.419.419 0 01-.278-.519zm-77.408 2.033a.42.42 0 01-.236.54 63.919 63.919 0 00-2.911 1.218.408.408 0 01-.541-.214.42.42 0 01.211-.551 65.321 65.321 0 012.947-1.233.408.408 0 01.53.24zm83.44 0a.408.408 0 01.53-.24c1.016.397 1.999.808 2.947 1.233a.42.42 0 01.211.551.408.408 0 01-.541.214 63.919 63.919 0 00-2.911-1.218.42.42 0 01-.236-.54zm5.823 2.573a.407.407 0 01.552-.182 45.55 45.55 0 012.798 1.579.422.422 0 01.14.573.406.406 0 01-.563.143 44.706 44.706 0 00-2.749-1.551.42.42 0 01-.178-.562zm-95.085 0a.421.421 0 01-.179.562 44.706 44.706 0 00-2.749 1.551.406.406 0 01-.563-.143.422.422 0 01.14-.573 45.55 45.55 0 012.798-1.579.408.408 0 01.553.182zm100.536 3.289a.405.405 0 01.573-.092c.906.673 1.74 1.365 2.496 2.077.167.156.177.42.023.59a.404.404 0 01-.579.023 27.506 27.506 0 00-2.423-2.015.42.42 0 01-.09-.583zm-105.988 0a.42.42 0 01-.09.583 27.338 27.338 0 00-2.423 2.016.404.404 0 01-.579-.024.422.422 0 01.023-.59 27.922 27.922 0 012.496-2.077.405.405 0 01.573.092zm110.687 4.322a.406.406 0 01.576.07c.705.91 1.29 1.846 1.744 2.806a.421.421 0 01-.192.557.408.408 0 01-.548-.195 14.43 14.43 0 00-1.648-2.651.423.423 0 01.068-.587zm-115.386.001a.422.422 0 01.068.586 14.43 14.43 0 00-1.648 2.651.408.408 0 01-.548.195.421.421 0 01-.192-.557 15.226 15.226 0 011.744-2.806.405.405 0 01.576-.069zm118.235 5.71a.41.41 0 01.47.346 10.661 10.661 0 010 3.351.41.41 0 01-.47.346.417.417 0 01-.34-.479 9.816 9.816 0 000-3.085.417.417 0 01.34-.479zm-121.083 0a.417.417 0 01.339.479 9.828 9.828 0 000 3.085.417.417 0 01-.339.479.411.411 0 01-.471-.346 10.649 10.649 0 010-3.351.411.411 0 01.471-.346zm120.362 6.321c.204.1.29.35.192.558a15.259 15.259 0 01-1.744 2.806.405.405 0 01-.576.069.423.423 0 01-.068-.587 14.342 14.342 0 001.648-2.651.408.408 0 01.548-.195zm-119.642 0a.408.408 0 01.548.195c.425.899.976 1.783 1.648 2.651.14.181.11.444-.068.587a.405.405 0 01-.576-.069 15.259 15.259 0 01-1.744-2.806.422.422 0 01.192-.558zm115.907 5.18a.423.423 0 01-.023.591 27.916 27.916 0 01-2.496 2.076.405.405 0 01-.573-.091.422.422 0 01.09-.584 27.332 27.332 0 002.423-2.015.404.404 0 01.579.023zm-112.172 0a.404.404 0 01.579-.023c.732.687 1.54 1.36 2.423 2.015a.422.422 0 01.09.584.405.405 0 01-.573.091 27.916 27.916 0 01-2.496-2.076.423.423 0 01-.023-.591zm107.119 3.894a.422.422 0 01-.14.573 45.55 45.55 0 01-2.798 1.579.406.406 0 01-.552-.182.42.42 0 01.178-.562 45.234 45.234 0 002.749-1.55.406.406 0 01.563.142zm-102.066 0a.406.406 0 01.563-.142 45.234 45.234 0 002.749 1.55.421.421 0 01.179.562.408.408 0 01-.553.182 45.55 45.55 0 01-2.798-1.579.422.422 0 01-.14-.573zm5.625 3a.407.407 0 01.541-.214c.935.419 1.906.825 2.911 1.217a.42.42 0 01.236.54.409.409 0 01-.53.241 65.318 65.318 0 01-2.947-1.234.42.42 0 01-.211-.55zm90.816 0a.42.42 0 01-.211.55c-.948.425-1.931.837-2.947 1.234a.409.409 0 01-.53-.241.42.42 0 01.236-.54 63.923 63.923 0 002.911-1.217.407.407 0 01.541.214zm-84.909 2.354a.409.409 0 01.519-.264c.979.335 1.985.658 3.016.967a.42.42 0 01.278.519.41.41 0 01-.51.283 85.894 85.894 0 01-3.045-.976.419.419 0 01-.258-.529zm79.002 0a.419.419 0 01-.258.529c-.989.338-2.004.663-3.045.976a.41.41 0 01-.51-.283.42.42 0 01.278-.519 82.288 82.288 0 003.016-.967.409.409 0 01.519.264zm-72.925 1.86a.41.41 0 01.5-.3c1.004.264 2.029.517 3.074.758a.418.418 0 01.309.5.41.41 0 01-.491.315 106.286 106.286 0 01-3.097-.764.418.418 0 01-.295-.509zm66.848 0a.418.418 0 01-.295.509c-1.012.266-2.045.521-3.097.764a.41.41 0 01-.491-.315.418.418 0 01.309-.5c1.045-.241 2.07-.494 3.074-.758a.41.41 0 01.5.3zm-60.659 1.453a.412.412 0 01.482-.329c1.023.205 2.062.398 3.116.58a.417.417 0 01.336.481.411.411 0 01-.473.343 119.22 119.22 0 01-3.137-.584.418.418 0 01-.324-.491zm54.47 0a.418.418 0 01-.324.491 119.22 119.22 0 01-3.137.584.411.411 0 01-.473-.343.417.417 0 01.336-.481c1.054-.182 2.093-.375 3.116-.58a.412.412 0 01.482.329zm-48.212 1.102a.41.41 0 01.464-.354c1.033.15 2.079.29 3.136.419a.416.416 0 01.359.464.411.411 0 01-.456.365 129.37 129.37 0 01-3.155-.421.417.417 0 01-.348-.473zm41.954 0a.417.417 0 01-.348.473 129.37 129.37 0 01-3.155.421.411.411 0 01-.456-.365.416.416 0 01.359-.464c1.058-.129 2.103-.269 3.136-.419a.41.41 0 01.464.354zm-35.655.785a.413.413 0 01.448-.376c1.041.102 2.092.193 3.153.272a.416.416 0 01.38.448.414.414 0 01-.44.386c-1.067-.08-2.125-.172-3.172-.274a.416.416 0 01-.369-.456zm29.356 0a.416.416 0 01-.369.456c-1.047.102-2.105.194-3.172.274a.414.414 0 01-.44-.386.417.417 0 01.38-.448c1.061-.079 2.112-.17 3.153-.272a.413.413 0 01.448.376zm-23.026.494a.413.413 0 01.431-.396c1.046.056 2.101.1 3.163.134.227.007.405.2.398.43a.414.414 0 01-.423.405 156.037 156.037 0 01-3.181-.134.415.415 0 01-.388-.439zm16.696 0a.415.415 0 01-.388.439c-1.052.055-2.113.1-3.181.134a.414.414 0 01-.423-.405.415.415 0 01.398-.43c1.062-.034 2.117-.078 3.163-.134a.413.413 0 01.431.396zm-10.35.218a.414.414 0 01.414-.414 139.751 139.751 0 003.176 0 .414.414 0 01.414.414.414.414 0 01-.406.422 169.143 169.143 0 01-3.192 0 .414.414 0 01-.406-.422z"
        fill="#7F9CF5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M708.232 305.007a253.42 253.42 0 014.621 0 .594.594 0 01.588.598.594.594 0 01-.6.586 219.519 219.519 0 00-4.597 0 .594.594 0 01-.6-.586.594.594 0 01.588-.598zm8.615.668a.594.594 0 01.612-.573c1.546.047 3.081.111 4.604.19a.592.592 0 11-.062 1.182 212.568 212.568 0 00-4.578-.189.594.594 0 01-.576-.61zm-12.609 0a.594.594 0 01-.576.61c-1.537.047-3.064.11-4.578.189a.593.593 0 11-.062-1.182c1.523-.079 3.057-.143 4.604-.19a.594.594 0 01.612.573zm21.788.451a.593.593 0 01.636-.546c1.545.113 3.075.242 4.591.387a.592.592 0 11-.114 1.178 203.23 203.23 0 00-4.564-.385.592.592 0 01-.549-.634zm-30.967 0a.592.592 0 01-.549.634 203.23 203.23 0 00-4.564.385.593.593 0 11-.114-1.178c1.516-.145 3.046-.274 4.591-.387a.593.593 0 01.636.546zm40.115.849a.593.593 0 01.66-.517c1.54.183 3.063.382 4.567.597a.592.592 0 11-.169 1.171 196.577 196.577 0 00-4.539-.593.592.592 0 01-.519-.658zm-49.263 0a.593.593 0 01-.519.658c-1.531.182-3.045.38-4.539.593a.592.592 0 11-.169-1.171c1.504-.215 3.027-.414 4.567-.597a.593.593 0 01.66.517zm58.357 1.273a.593.593 0 01.685-.485c1.536.259 3.05.535 4.541.827a.591.591 0 11-.229 1.161c-1.481-.29-2.984-.564-4.511-.821a.592.592 0 01-.486-.682zm-67.451 0a.592.592 0 01-.486.682c-1.527.257-3.03.531-4.511.821a.591.591 0 11-.229-1.161c1.491-.292 3.005-.568 4.541-.827a.593.593 0 01.685.485zm76.482 1.738a.595.595 0 01.711-.446c1.523.343 3.018.704 4.484 1.082a.592.592 0 11-.298 1.146 149.568 149.568 0 00-4.448-1.074.593.593 0 01-.449-.708zm-85.514 0a.591.591 0 01-.448.708c-1.511.341-2.995.699-4.448 1.074a.592.592 0 11-.298-1.146c1.466-.378 2.961-.739 4.484-1.082a.594.594 0 01.71.446zm-8.897 2.259a.592.592 0 01-.402.735c-1.493.439-2.948.895-4.365 1.369a.593.593 0 11-.379-1.121c1.432-.479 2.902-.94 4.408-1.383a.595.595 0 01.738.4zm103.309 0a.595.595 0 01.738-.4c1.506.443 2.976.904 4.407 1.383a.59.59 0 11-.378 1.121c-1.417-.474-2.872-.93-4.365-1.369a.59.59 0 01-.402-.735zm-112.039 2.88a.591.591 0 01-.342.764 95.776 95.776 0 00-4.213 1.724.591.591 0 11-.479-1.083 95.79 95.79 0 014.267-1.746.595.595 0 01.767.341zm120.769 0a.595.595 0 01.767-.341 95.79 95.79 0 014.267 1.746.591.591 0 11-.479 1.083 95.776 95.776 0 00-4.213-1.724.591.591 0 01-.342-.764zm8.428 3.643a.596.596 0 01.799-.258 66.67 66.67 0 014.051 2.236.59.59 0 01.202.812.595.595 0 01-.815.202 65.002 65.002 0 00-3.978-2.196.59.59 0 01-.259-.796zm-137.625 0a.591.591 0 01-.259.796 65.002 65.002 0 00-3.978 2.196.595.595 0 01-.815-.202.59.59 0 01.202-.812 66.67 66.67 0 014.051-2.236.596.596 0 01.799.258zm145.515 4.657a.596.596 0 01.83-.13 40.254 40.254 0 013.613 2.941.59.59 0 01.033.836.595.595 0 01-.839.033 39.404 39.404 0 00-3.507-2.854.59.59 0 01-.13-.826zm-153.405 0a.59.59 0 01-.13.826 39.404 39.404 0 00-3.507 2.854.595.595 0 01-.839-.033.59.59 0 01.033-.836 40.254 40.254 0 013.613-2.941.596.596 0 01.83.13zm160.207 6.121a.596.596 0 01.834.098c1.02 1.289 1.866 2.615 2.523 3.974a.589.589 0 01-.277.789.595.595 0 01-.793-.276c-.615-1.272-1.413-2.525-2.386-3.754a.59.59 0 01.099-.831zm-167.009 0a.59.59 0 01.099.831c-.973 1.229-1.771 2.482-2.386 3.754a.596.596 0 01-.793.276.589.589 0 01-.277-.789c.657-1.359 1.503-2.685 2.523-3.974a.596.596 0 01.834-.098zm171.131 8.087a.595.595 0 01.682.49 14.816 14.816 0 010 4.746.595.595 0 01-1.173-.189 13.651 13.651 0 000-4.369.592.592 0 01.491-.678zm-175.254 0a.592.592 0 01.492.678 13.654 13.654 0 000 4.369.594.594 0 01-1.173.189 14.827 14.827 0 010-4.746.594.594 0 01.681-.49zm174.212 8.951a.59.59 0 01.277.79c-.657 1.359-1.503 2.684-2.523 3.973a.596.596 0 01-.834.098.59.59 0 01-.099-.831c.973-1.229 1.771-2.482 2.386-3.754a.595.595 0 01.793-.276zm-173.169 0a.596.596 0 01.793.276c.615 1.272 1.413 2.525 2.386 3.754a.59.59 0 01-.099.831.596.596 0 01-.834-.098c-1.02-1.289-1.866-2.614-2.523-3.973a.59.59 0 01.277-.79zm167.763 7.336a.59.59 0 01-.033.836 40.422 40.422 0 01-3.613 2.94.595.595 0 01-.83-.129.59.59 0 01.13-.827 39.229 39.229 0 003.507-2.854.595.595 0 01.839.034zm-162.357 0a.595.595 0 01.839-.034 39.055 39.055 0 003.507 2.854c.265.192.323.563.13.827s-.565.322-.83.129a40.422 40.422 0 01-3.613-2.94.59.59 0 01-.033-.836zm155.043 5.513a.59.59 0 01-.202.812 66.67 66.67 0 01-4.051 2.236.591.591 0 11-.54-1.054 65.542 65.542 0 003.978-2.195.594.594 0 01.815.201zm-147.729 0a.594.594 0 01.815-.201 65.542 65.542 0 003.978 2.195.591.591 0 11-.54 1.054 66.67 66.67 0 01-4.051-2.236.59.59 0 01-.202-.812zm8.142 4.248a.595.595 0 01.783-.303 94.563 94.563 0 004.213 1.724.591.591 0 11-.425 1.105 94.606 94.606 0 01-4.267-1.746.591.591 0 01-.304-.78zm131.445 0a.591.591 0 01-.304.78 94.606 94.606 0 01-4.267 1.746.591.591 0 11-.425-1.105 94.563 94.563 0 004.213-1.724c.3-.132.651.004.783.303zm-122.896 3.333a.594.594 0 01.752-.372c1.417.474 2.872.931 4.365 1.369a.592.592 0 11-.336 1.135 123.823 123.823 0 01-4.408-1.383.59.59 0 01-.373-.749zm114.347 0a.59.59 0 01-.374.749c-1.431.479-2.901.941-4.407 1.383a.59.59 0 11-.336-1.135 122.18 122.18 0 004.365-1.369.594.594 0 01.752.372zm-105.551 2.634a.594.594 0 01.724-.424c1.453.374 2.937.732 4.448 1.073a.591.591 0 11-.262 1.154 149.646 149.646 0 01-4.484-1.082.592.592 0 01-.426-.721zm96.755 0a.592.592 0 01-.426.721c-1.466.378-2.961.739-4.484 1.082a.593.593 0 11-.262-1.154c1.511-.341 2.995-.699 4.448-1.073a.594.594 0 01.724.424zm-87.797 2.059a.592.592 0 01.697-.466c1.481.289 2.984.563 4.511.82a.592.592 0 11-.199 1.167c-1.536-.259-3.05-.534-4.541-.826a.592.592 0 01-.468-.695zm78.839 0a.592.592 0 01-.468.695c-1.491.292-3.005.567-4.541.826a.593.593 0 11-.199-1.167c1.527-.257 3.03-.531 4.511-.82a.592.592 0 01.697.466zm-69.782 1.56a.595.595 0 01.673-.502c1.494.214 3.008.412 4.539.593a.593.593 0 11-.141 1.175c-1.54-.182-3.063-.382-4.567-.597a.592.592 0 01-.504-.669zm60.725 0a.592.592 0 01-.504.669c-1.504.215-3.027.415-4.567.597a.592.592 0 11-.141-1.175c1.531-.181 3.045-.379 4.539-.593a.595.595 0 01.673.502zm-51.607 1.111a.593.593 0 01.648-.532c1.506.144 3.028.273 4.564.385a.592.592 0 11-.087 1.181 212.289 212.289 0 01-4.591-.388.591.591 0 01-.534-.646zm42.489 0a.592.592 0 01-.534.646c-1.516.145-3.046.274-4.591.388a.592.592 0 11-.087-1.181 203.23 203.23 0 004.564-.385.593.593 0 01.648.532zm-33.327.7a.592.592 0 01.624-.56c1.514.078 3.041.141 4.578.189.328.01.586.283.576.609a.593.593 0 01-.612.573 214.722 214.722 0 01-4.604-.19.592.592 0 01-.562-.621zm24.165 0a.592.592 0 01-.562.621c-1.523.079-3.057.143-4.604.19a.593.593 0 01-.612-.573.593.593 0 01.576-.609c1.537-.048 3.064-.111 4.578-.189a.592.592 0 01.624.56zm-14.981.308a.592.592 0 01.6-.585 250.79 250.79 0 004.597 0 .592.592 0 11.012 1.183 221.82 221.82 0 01-4.621 0 .594.594 0 01-.588-.598z"
        fill="#A0AEC0"
      />
      <g filter="url(#prefix__filter22_d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M807.625 356.591c5.263-5.047 8.033-10.459 8.033-16.015 0-5.556-2.77-10.968-8.033-16.016-5.265-5.051-12.949-9.655-22.545-13.548-19.184-7.784-45.772-12.626-75.202-12.626-29.431 0-56.019 4.842-75.203 12.626-9.596 3.893-17.28 8.497-22.545 13.548-5.262 5.048-8.033 10.46-8.033 16.016 0 5.556 2.771 10.968 8.033 16.015 5.265 5.051 12.949 9.656 22.545 13.549 19.184 7.784 45.772 12.626 75.203 12.626 29.43 0 56.018-4.842 75.202-12.626 9.596-3.893 17.28-8.498 22.545-13.549zm-97.747 27.398c59.096 0 107.003-19.437 107.003-43.413 0-23.976-47.907-43.413-107.003-43.413-59.097 0-107.004 19.437-107.004 43.413 0 23.976 47.907 43.413 107.004 43.413z"
          fill="#4C51BF"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M808.803 332.131c5.293-5.048 8.078-10.46 8.078-16.013 0-5.554-2.785-10.965-8.078-16.013-5.296-5.052-13.025-9.657-22.676-13.551-19.297-7.784-46.038-12.626-75.638-12.626-29.6 0-56.341 4.842-75.638 12.626-9.651 3.894-17.38 8.499-22.676 13.551-5.293 5.048-8.078 10.459-8.078 16.013 0 5.553 2.785 10.965 8.078 16.013 5.296 5.051 13.025 9.657 22.676 13.55 19.297 7.784 46.038 12.627 75.638 12.627 29.6 0 56.341-4.843 75.638-12.627 9.651-3.893 17.38-8.499 22.676-13.55zm-98.314 27.4c59.434 0 107.615-19.437 107.615-43.413 0-23.976-48.181-43.413-107.615-43.413s-107.615 19.437-107.615 43.413c0 23.976 48.181 43.413 107.615 43.413z"
        fill="#4C51BF"
      />
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M808.803 307.673c5.293-5.048 8.078-10.46 8.078-16.013 0-5.553-2.785-10.965-8.078-16.013-5.296-5.052-13.025-9.657-22.676-13.55-19.297-7.785-46.038-12.627-75.638-12.627-29.6 0-56.341 4.842-75.638 12.627-9.651 3.893-17.38 8.498-22.676 13.55-5.293 5.048-8.078 10.46-8.078 16.013 0 5.553 2.785 10.965 8.078 16.013 5.296 5.052 13.025 9.657 22.676 13.55 19.297 7.785 46.038 12.627 75.638 12.627 29.6 0 56.341-4.842 75.638-12.627 9.651-3.893 17.38-8.498 22.676-13.55zm-98.314 27.4c59.434 0 107.615-19.437 107.615-43.413 0-23.976-48.181-43.413-107.615-43.413s-107.615 19.437-107.615 43.413c0 23.976 48.181 43.413 107.615 43.413z"
        fill="#4C51BF"
      />
      <path
        opacity={0.1}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M808.803 283.216c5.293-5.049 8.078-10.46 8.078-16.014 0-5.553-2.785-10.965-8.078-16.013-5.296-5.051-13.025-9.657-22.676-13.55-19.297-7.784-46.038-12.627-75.638-12.627-29.6 0-56.341 4.843-75.638 12.627-9.651 3.893-17.38 8.499-22.676 13.55-5.293 5.048-8.078 10.46-8.078 16.013 0 5.554 2.785 10.965 8.078 16.014 5.296 5.051 13.025 9.656 22.676 13.55 19.297 7.784 46.038 12.626 75.638 12.626 29.6 0 56.341-4.842 75.638-12.626 9.651-3.894 17.38-8.499 22.676-13.55zm-98.314 27.399c59.434 0 107.615-19.437 107.615-43.413 0-23.976-48.181-43.412-107.615-43.412s-107.615 19.436-107.615 43.412 48.181 43.413 107.615 43.413z"
        fill="#4C51BF"
      />
      <g className="rocket">
        <path
          d="M771.633 234.795l-84.736 67.625 6.356-24.969 78.38-42.656z"
          fill="#434190"
        />
        <path
          d="M737.21 304.5l34.424-69.705-78.381 42.656L737.21 304.5zm-100.095-43.695l38.131 8.323 96.387-34.333-134.518 26.01z"
          fill="#4C51BF"
        />
        <path
          d="M686.897 302.42l6.356-24.969 78.38-42.656-96.387 34.333 11.651 33.292z"
          fill="#A3BFFA"
        />
      </g>
      <g filter="url(#prefix__filter23_f)">
        <ellipse
          cx={541.46}
          cy={325.901}
          rx={20.789}
          ry={3.057}
          fill="#CBD5E0"
        />
      </g>
      <g filter="url(#prefix__filter24_f)">
        <ellipse
          cx={921.168}
          cy={541.13}
          rx={21.401}
          ry={3.057}
          fill="#CBD5E0"
        />
      </g>
      <g className="small-rocket2">
        <path
          d="M507.043 244.996l37.165 29.659-2.788-10.951-34.377-18.708z"
          fill="#5E8E3E"
        />
        <path
          d="M522.141 275.568l-15.098-30.572 34.377 18.708-19.279 11.864z"
          fill="#95BF46"
        />
        <path
          d="M566.042 256.403l-16.724 3.651-42.275-15.058 58.999 11.407z"
          fill="#95BF46"
        />
        <path
          d="M544.207 274.655l-2.787-10.951-34.377-18.708 42.275 15.058-5.111 14.601z"
          fill="#D5F39B"
        />
      </g>
      <g className="small-rocket">
        <path
          d="M887.809 463.477l37.165 29.659-2.788-10.951-34.377-18.708z"
          fill="#5E8E3E"
        />
        <path
          d="M902.907 494.049l-15.099-30.572 34.378 18.708-19.279 11.864zm43.901-19.165l-16.724 3.651-42.275-15.058 58.999 11.407z"
          fill="#95BF46"
        />
        <path
          d="M924.973 493.136l-2.787-10.951-34.377-18.708 42.275 15.058-5.111 14.601z"
          fill="#D5F39B"
        />
      </g>
      <g filter="url(#prefix__filter25_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M629.042 461.996c-2.761 0-5-.261-5-.582v-26.837c0-.321 2.239-.581 5-.581 2.762 0 5 .26 5 .581v26.837c0 .321-2.238.582-5 .582z"
          fill="#A0AEC0"
        />
      </g>
      <ellipse cx={623.624} cy={448.07} rx={9.172} ry={11.617} fill="#EDF2F7" />
      <ellipse
        cx={621.179}
        cy={449.293}
        rx={9.172}
        ry={11.617}
        fill="#A0AEC0"
      />
      <g filter="url(#prefix__filter26_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M506.587 514.118l110.728-61.044-.59-1.071-110.138 60.718v1.397z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter27_di)">
        <path
          d="M506.587 521.1l116.892-64.442a7.95 7.95 0 00-7.675-13.922l-109.217 60.211V521.1z"
          fill="#F7FAFC"
        />
      </g>
      <g filter="url(#prefix__filter28_di)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M295.53 355.725c2.195-3.802 8.496-4.274 14.073-1.054l466.078 269.091c5.578 3.22 8.319 8.912 6.124 12.714-2.195 3.802-8.495 4.273-14.072 1.053l-466.079-269.09c-5.577-3.22-8.319-8.912-6.124-12.714z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter29_i)">
        <circle
          cx={715.089}
          cy={597.521}
          r={7.337}
          transform="rotate(58.868 715.089 597.521)"
          fill="#5A67D8"
        />
      </g>
      <g filter="url(#prefix__filter30_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M775.153 635.293L227.049 318.845l1.078-1.868 548.104 316.448-1.078 1.868z"
          fill="#fff"
        />
      </g>
      <ellipse
        cx={633.914}
        cy={554.007}
        rx={8.093}
        ry={10.251}
        fill="#CBD5E0"
      />
      <ellipse
        cx={631.756}
        cy={555.087}
        rx={8.093}
        ry={10.251}
        fill="#A0AEC0"
      />
      <ellipse cx={536.082} cy={495.74} rx={8.093} ry={10.251} fill="#CBD5E0" />
      <ellipse
        cx={533.924}
        cy={496.819}
        rx={8.093}
        ry={10.251}
        fill="#A0AEC0"
      />
      <ellipse
        cx={774.547}
        cy={635.149}
        rx={8.093}
        ry={10.251}
        fill="#CBD5E0"
      />
      <ellipse
        cx={772.389}
        cy={636.229}
        rx={8.093}
        ry={10.251}
        fill="#A0AEC0"
      />
      <ellipse cx={412.57} cy={426.826} rx={8.093} ry={10.251} fill="#CBD5E0" />
      <ellipse
        cx={410.412}
        cy={427.906}
        rx={8.093}
        ry={10.251}
        fill="#A0AEC0"
      />
      <ellipse
        cx={301.287}
        cy={362.444}
        rx={8.093}
        ry={10.251}
        fill="#CBD5E0"
      />
      <ellipse
        cx={299.129}
        cy={363.524}
        rx={8.093}
        ry={10.251}
        fill="#A0AEC0"
      />
      <g filter="url(#prefix__filter31_di)">
        <path
          d="M150.134 453.587l150.115-82.758a7.95 7.95 0 00-7.676-13.922l-142.439 78.526v18.154z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter32_i)">
        <circle cx={273.725} cy={376.305} r={7.337} fill="#5A67D8" />
      </g>
      <g filter="url(#prefix__filter33_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M294.084 367.246l-191.785 105.73-.59-1.071 191.785-105.73.59 1.071z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter34_di)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.453 609.639a7.948 7.948 0 013.124-10.798l321.28-177.12a7.949 7.949 0 017.675 13.922l-321.28 177.12a7.949 7.949 0 01-10.799-3.124z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter35_i)">
        <circle cx={298.183} cy={488.811} r={7.337} fill="#5A67D8" />
      </g>
      <g filter="url(#prefix__filter36_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M405.367 432.059L91.048 605.342l-.59-1.071 314.319-173.283.59 1.071z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter37_di)">
        <path
          d="M383.976 587.408l151.068-83.283a7.95 7.95 0 10-7.675-13.922l-143.393 79.052v18.153z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter38_i)">
        <circle cx={510.966} cy={508.376} r={7.337} fill="#5A67D8" />
      </g>
      <g filter="url(#prefix__filter39_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M533.709 497.879L214.561 673.824l-.591-1.071 319.149-175.945.59 1.071z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter40_di)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M300.797 736.82a7.948 7.948 0 013.124-10.798L625.2 548.902a7.949 7.949 0 117.675 13.922l-321.279 177.12a7.95 7.95 0 01-10.799-3.124z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter41_i)">
        <circle cx={421.886} cy={670.145} r={7.337} fill="#5A67D8" />
      </g>
      <g filter="url(#prefix__filter42_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M626.711 559.24L312.392 732.523l-.59-1.071L626.12 558.169l.591 1.071z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter43_di)">
        <path
          d="M640.784 716.705l132.724-73.17a7.95 7.95 0 10-7.675-13.922l-125.049 68.939v18.153z"
          fill="#F7FAFC"
        />
      </g>
      <g opacity={0.5} filter="url(#prefix__filter44_i)">
        <circle cx={704.183} cy={672.245} r={7.337} fill="#5A67D8" />
      </g>
      <g filter="url(#prefix__filter45_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M767.343 639.951l-177.424 97.814-.591-1.071 177.425-97.814.59 1.071z"
          fill="#fff"
        />
      </g>
      <g filter="url(#prefix__filter46_i)">
        <ellipse
          cx={136.202}
          cy={464.187}
          rx={64.064}
          ry={26.194}
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter47_i)" fill="#EDF2F7">
        <path d="M191.43 462.293c0 12.375-24.726 22.407-55.228 22.407-30.501 0-55.227-10.032-55.227-22.407s24.726-22.407 55.227-22.407c30.502 0 55.228 10.032 55.228 22.407z" />
        <path d="M80.975 415.271H191.43v47.338H80.975v-47.338z" />
      </g>
      <g opacity={0.6} filter="url(#prefix__filter48_f)">
        <path
          d="M138.112 458.822c-21.557 0-35.292-26.93-39.464-40.395h75.109c-2.9 13.465-14.088 40.395-35.645 40.395z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter49_d)">
        <ellipse
          cx={136.202}
          cy={414.955}
          rx={55.227}
          ry={22.407}
          fill="#5A67D8"
        />
      </g>
      <g filter="url(#prefix__filter50_i)">
        <ellipse
          cx={136.202}
          cy={414.955}
          rx={39.448}
          ry={16.095}
          fill="#EDF2F7"
        />
      </g>
      <g filter="url(#prefix__filter51_i)">
        <ellipse
          cx={615.577}
          cy={743.006}
          rx={64.064}
          ry={26.194}
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter52_i)" fill="#EDF2F7">
        <path d="M670.804 741.113c0 12.375-24.726 22.406-55.227 22.406-30.502 0-55.228-10.031-55.228-22.406 0-12.375 24.726-22.407 55.228-22.407 30.501 0 55.227 10.032 55.227 22.407z" />
        <path d="M560.349 694.091h110.455v47.337H560.349v-47.337z" />
      </g>
      <g opacity={0.6} filter="url(#prefix__filter53_f)">
        <path
          d="M617.486 737.642c-21.557 0-35.291-26.93-39.464-40.395h75.109c-2.899 13.465-14.088 40.395-35.645 40.395z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter54_d)">
        <ellipse
          cx={615.577}
          cy={693.775}
          rx={55.227}
          ry={22.407}
          fill="#5A67D8"
        />
      </g>
      <g filter="url(#prefix__filter55_i)">
        <ellipse
          cx={615.577}
          cy={693.775}
          rx={39.448}
          ry={16.095}
          fill="#EDF2F7"
        />
      </g>
      <g filter="url(#prefix__filter56_i)">
        <ellipse
          cx={287.979}
          cy={757.968}
          rx={44.636}
          ry={18.25}
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter57_i)" fill="#EDF2F7">
        <path d="M326.458 756.649c0 8.622-17.227 15.611-38.479 15.611-21.251 0-38.479-6.989-38.479-15.611s17.228-15.612 38.479-15.612c21.252 0 38.479 6.99 38.479 15.612z" />
        <path d="M249.5 723.886h76.958v32.982H249.5v-32.982z" />
      </g>
      <g opacity={0.6} filter="url(#prefix__filter58_f)">
        <path
          d="M289.31 754.23c-15.02 0-24.589-18.763-27.497-28.145h52.332c-2.02 9.382-9.816 28.145-24.835 28.145z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter59_d)">
        <ellipse
          cx={287.979}
          cy={723.667}
          rx={38.479}
          ry={15.611}
          fill="#5A67D8"
        />
      </g>
      <g filter="url(#prefix__filter60_i)">
        <ellipse
          cx={287.979}
          cy={723.666}
          rx={27.485}
          ry={11.214}
          fill="#EDF2F7"
        />
      </g>
      <g filter="url(#prefix__filter61_i)">
        <ellipse
          cx={66.636}
          cy={632.01}
          rx={44.636}
          ry={18.25}
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter62_i)" fill="#EDF2F7">
        <path d="M105.114 630.691c0 8.622-17.227 15.611-38.478 15.611-21.252 0-38.48-6.989-38.48-15.611s17.228-15.612 38.48-15.612c21.25 0 38.478 6.99 38.478 15.612z" />
        <path d="M28.157 597.928h76.957v32.982H28.157v-32.982z" />
      </g>
      <g opacity={0.6} filter="url(#prefix__filter63_f)">
        <path
          d="M67.966 628.272c-15.02 0-24.589-18.763-27.496-28.145H92.8c-2.02 9.382-9.816 28.145-24.835 28.145z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter64_d)">
        <ellipse
          cx={66.635}
          cy={597.709}
          rx={38.479}
          ry={15.611}
          fill="#5A67D8"
        />
      </g>
      <g filter="url(#prefix__filter65_i)">
        <ellipse
          cx={66.636}
          cy={597.708}
          rx={27.485}
          ry={11.214}
          fill="#EDF2F7"
        />
      </g>
      <g filter="url(#prefix__filter66_i)">
        <ellipse
          cx={375.89}
          cy={603.597}
          rx={64.064}
          ry={26.194}
          fill="#E2E8F0"
        />
      </g>
      <g filter="url(#prefix__filter67_i)" fill="#EDF2F7">
        <path d="M431.117 601.703c0 12.375-24.726 22.406-55.228 22.406-30.501 0-55.227-10.031-55.227-22.406 0-12.375 24.726-22.407 55.227-22.407 30.502 0 55.228 10.032 55.228 22.407z" />
        <path d="M320.662 554.681h110.455v47.337H320.662v-47.337z" />
      </g>
      <g opacity={0.6} filter="url(#prefix__filter68_f)">
        <path
          d="M377.799 598.232c-21.557 0-35.291-26.93-39.464-40.395h75.109c-2.9 13.465-14.088 40.395-35.645 40.395z"
          fill="#A0AEC0"
        />
      </g>
      <g filter="url(#prefix__filter69_d)">
        <ellipse
          cx={375.89}
          cy={554.365}
          rx={55.227}
          ry={22.407}
          fill="#5A67D8"
        />
      </g>
      <g filter="url(#prefix__filter70_i)">
        <ellipse
          cx={375.89}
          cy={554.365}
          rx={39.448}
          ry={16.095}
          fill="#EDF2F7"
        />
      </g>
      <g filter="url(#prefix__filter71_f)">
        <ellipse
          cx={67.655}
          cy={597.995}
          rx={11.414}
          ry={2.446}
          fill="#718096"
        />
      </g>
      <g filter="url(#prefix__filter72_f)">
        <ellipse
          cx={138.516}
          cy={415.172}
          rx={21.401}
          ry={3.057}
          fill="#718096"
        />
      </g>
      <g filter="url(#prefix__filter73_f)">
        <ellipse
          cx={376.639}
          cy={555.805}
          rx={17.12}
          ry={3.057}
          fill="#718096"
        />
      </g>
      <g filter="url(#prefix__filter74_f)">
        <ellipse
          cx={615.103}
          cy={695.215}
          rx={17.12}
          ry={3.057}
          fill="#718096"
        />
      </g>
      <g filter="url(#prefix__filter75_f)">
        <ellipse
          cx={288.998}
          cy={723.953}
          rx={11.414}
          ry={2.446}
          fill="#718096"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M797.314 457.467c-10.356 5.881-23.382 10.101-34.241 12.715v-42.169c0-9.455 7.665-17.12 17.121-17.12 9.455 0 17.12 7.665 17.12 17.12v29.454z"
        fill="#4A5568"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M792.123 460.179a87.39 87.39 0 005.191-2.712v-29.454c0-9.456-7.665-17.121-17.12-17.121-3.237 0-6.264.898-8.845 2.459a17.077 17.077 0 016.399-1.236c9.455 0 17.121 7.665 17.121 17.12v29.455a83.112 83.112 0 01-2.746 1.489z"
        fill="#EDF2F7"
      />
      <ellipse
        cx={372.897}
        cy={521.557}
        rx={21.401}
        ry={30.489}
        transform="rotate(1.421 372.897 521.557)"
        fill="#A0AEC0"
      />
      <path
        d="M379.19 489.825c-3.424-.085-9.622 1.596-11.064 2.172l3.622 1.925c1.218.234 3.65.824 3.637 1.313-.015.611 8.083-5.304 3.805-5.41zm4.626 60.055c-3.115 1.423-9.512 2.135-11.063 2.172l1.466-2.396c1.028-.693 3.032-2.192 2.829-2.637-.254-.556 10.661 1.082 6.768 2.861z"
        fill="#A0AEC0"
      />
      <ellipse
        cx={379.045}
        cy={520.319}
        rx={21.401}
        ry={30.489}
        transform="rotate(1.421 379.045 520.319)"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter76_d)" fill="#718096">
        <path d="M379.571 501.162c-7.318-.181-13.717 8.471-13.976 18.896-.152 6.133 1.859 11.742 5.021 15.373l-.003.146.137.003c2.193 2.45 4.914 3.971 7.866 4.044 2.953.073 5.746-1.31 8.057-3.649l.138.004.004-.146c3.338-3.47 5.625-8.97 5.777-15.105.259-10.425-5.704-19.384-13.021-19.566zm-6.108 32.421c.231-1.277.759-2.412 1.498-3.217.738-.805 1.643-1.233 2.565-1.212l2.699.067c.922.025 1.804.497 2.501 1.338.698.841 1.169 2 1.337 3.287-1.609 1.263-3.44 1.979-5.351 1.932-1.912-.048-3.704-.854-5.249-2.195zm12.934-2.154c-.471-1.759-1.299-3.272-2.38-4.349-1.081-1.077-2.367-1.67-3.696-1.705l-2.7-.067c-1.33-.031-2.643.498-3.776 1.52s-2.035 2.492-2.593 4.225c-1.911-2.855-3.061-6.743-2.957-10.928.207-8.34 5.326-15.262 11.18-15.117 5.855.146 10.624 7.313 10.418 15.653-.104 4.185-1.446 8.011-3.496 10.768z" />
        <path d="M379.38 508.854c-3.078-.076-5.482 3.174-5.59 7.559-.109 4.384 2.13 7.75 5.208 7.826 3.078.077 5.482-3.174 5.591-7.558.108-4.385-2.131-7.75-5.209-7.827zm-.286 11.539c-1.591-.04-2.661-1.648-2.605-3.913.057-2.266 1.205-3.819 2.795-3.779 1.591.039 2.661 1.647 2.605 3.913-.056 2.265-1.205 3.818-2.795 3.779z" />
      </g>
      <ellipse
        cx={133.21}
        cy={380.925}
        rx={21.401}
        ry={30.489}
        transform="rotate(1.421 133.21 380.925)"
        fill="#A0AEC0"
      />
      <path
        d="M139.502 349.192c-3.423-.085-9.621 1.596-11.063 2.172l3.622 1.925c1.218.234 3.649.824 3.637 1.313-.015.612 8.083-5.304 3.804-5.41zm4.626 60.055c-3.114 1.423-9.511 2.135-11.063 2.172l1.467-2.396c1.027-.693 3.032-2.192 2.829-2.637-.255-.556 10.66 1.082 6.767 2.861z"
        fill="#A0AEC0"
      />
      <ellipse
        cx={139.357}
        cy={379.686}
        rx={21.401}
        ry={30.489}
        transform="rotate(1.421 139.357 379.686)"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter77_d)" fill="#718096">
        <path d="M139.884 360.529c-7.318-.181-13.717 8.471-13.976 18.896-.152 6.133 1.859 11.742 5.021 15.373l-.003.146.137.003c2.192 2.451 4.914 3.971 7.866 4.044 2.953.073 5.746-1.31 8.057-3.648l.138.003.004-.146c3.338-3.47 5.625-8.97 5.777-15.105.259-10.425-5.704-19.384-13.021-19.566zm-6.108 32.421c.231-1.277.759-2.412 1.498-3.217.738-.805 1.643-1.233 2.565-1.212l2.699.067c.922.026 1.804.498 2.501 1.338.698.841 1.169 2 1.337 3.287-1.609 1.263-3.44 1.979-5.351 1.932-1.912-.047-3.704-.854-5.249-2.195zm12.934-2.154c-.471-1.759-1.299-3.272-2.38-4.349-1.081-1.077-2.367-1.67-3.696-1.705l-2.7-.067c-1.33-.031-2.643.498-3.776 1.52s-2.035 2.492-2.593 4.225c-1.911-2.854-3.061-6.743-2.957-10.928.207-8.34 5.326-15.262 11.18-15.117 5.855.146 10.624 7.313 10.418 15.653-.104 4.185-1.446 8.012-3.496 10.768z" />
        <path d="M139.693 368.222c-3.078-.077-5.482 3.173-5.59 7.558-.109 4.385 2.13 7.75 5.208 7.826 3.078.077 5.482-3.173 5.59-7.558.109-4.385-2.13-7.75-5.208-7.826zm-.286 11.538c-1.591-.039-2.661-1.648-2.605-3.913.057-2.265 1.205-3.819 2.795-3.779 1.591.039 2.661 1.648 2.605 3.913-.056 2.265-1.205 3.819-2.795 3.779z" />
      </g>
      <ellipse
        cx={65.305}
        cy={572.177}
        rx={16.064}
        ry={22.886}
        transform="rotate(1.421 65.305 572.177)"
        fill="#A0AEC0"
      />
      <path
        d="M70.028 548.358c-2.57-.064-7.223 1.198-8.305 1.63l2.719 1.445c.914.175 2.74.619 2.73.986-.011.458 6.067-3.982 2.856-4.061zm3.472 45.079c-2.338 1.068-7.14 1.602-8.304 1.63l1.1-1.798c.772-.521 2.276-1.646 2.124-1.98-.191-.417 8.002.812 5.08 2.148z"
        fill="#A0AEC0"
      />
      <ellipse
        cx={69.919}
        cy={571.247}
        rx={16.064}
        ry={22.886}
        transform="rotate(1.421 69.919 571.247)"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter78_d)" fill="#718096">
        <path d="M70.314 556.867c-5.493-.136-10.297 6.359-10.49 14.184-.115 4.604 1.394 8.814 3.768 11.539l-.002.11.103.003c1.645 1.839 3.688 2.98 5.904 3.035 2.216.055 4.313-.984 6.048-2.739l.103.003.003-.11c2.506-2.604 4.223-6.733 4.337-11.338.194-7.825-4.281-14.55-9.774-14.687zm-4.584 24.336c.173-.958.57-1.81 1.123-2.414.555-.605 1.234-.926 1.926-.91l2.026.05c.692.019 1.354.373 1.877 1.005.524.631.878 1.501 1.004 2.467-1.208.948-2.582 1.485-4.017 1.45-1.435-.036-2.78-.641-3.94-1.648zm9.708-1.616c-.354-1.321-.976-2.456-1.787-3.265-.811-.808-1.776-1.253-2.774-1.28l-2.027-.05c-.998-.023-1.984.374-2.834 1.141s-1.528 1.87-1.947 3.172c-1.434-2.143-2.297-5.062-2.22-8.203.156-6.261 3.999-11.457 8.393-11.348 4.395.109 7.975 5.489 7.82 11.75-.078 3.141-1.085 6.013-2.624 8.083z" />
        <path d="M70.17 562.641c-2.31-.057-4.114 2.383-4.196 5.674-.081 3.291 1.6 5.817 3.91 5.875 2.31.057 4.115-2.383 4.196-5.674.082-3.291-1.6-5.817-3.91-5.875zm-.214 8.662c-1.194-.03-1.997-1.237-1.955-2.938.042-1.7.904-2.866 2.098-2.837 1.193.03 1.997 1.237 1.955 2.938-.042 1.7-.905 2.866-2.098 2.837z" />
      </g>
      <ellipse
        cx={285.425}
        cy={698.135}
        rx={16.064}
        ry={22.886}
        transform="rotate(1.421 285.425 698.135)"
        fill="#A0AEC0"
      />
      <path
        d="M290.149 674.316c-2.57-.064-7.223 1.198-8.305 1.63l2.719 1.445c.914.175 2.739.619 2.73.986-.011.458 6.067-3.982 2.856-4.061zm3.472 45.079c-2.338 1.068-7.14 1.602-8.304 1.63l1.1-1.798c.772-.521 2.276-1.646 2.124-1.98-.191-.417 8.002.812 5.08 2.148z"
        fill="#A0AEC0"
      />
      <ellipse
        cx={290.04}
        cy={697.206}
        rx={16.064}
        ry={22.886}
        transform="rotate(1.421 290.04 697.206)"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter79_d)" fill="#718096">
        <path d="M290.435 682.825c-5.493-.136-10.297 6.359-10.491 14.184-.114 4.604 1.395 8.814 3.769 11.539l-.003.11.104.003c1.645 1.839 3.688 2.98 5.904 3.035 2.216.055 4.313-.984 6.048-2.739l.103.003.003-.11c2.506-2.604 4.223-6.733 4.337-11.338.194-7.825-4.281-14.55-9.774-14.687zm-4.585 24.336c.174-.958.57-1.81 1.124-2.414.555-.605 1.234-.926 1.925-.91l2.027.05c.692.019 1.354.374 1.877 1.005.524.631.878 1.501 1.003 2.467-1.207.948-2.581 1.485-4.016 1.45-1.435-.036-2.78-.641-3.94-1.648zm9.709-1.616c-.354-1.321-.976-2.456-1.787-3.265-.811-.808-1.776-1.253-2.774-1.28l-2.027-.05c-.998-.023-1.984.374-2.834 1.141-.851.767-1.528 1.87-1.947 3.172-1.434-2.143-2.297-5.062-2.219-8.203.155-6.261 3.998-11.457 8.392-11.348 4.395.109 7.975 5.489 7.819 11.75-.077 3.141-1.085 6.013-2.623 8.083z" />
        <path d="M290.291 688.599c-2.31-.057-4.114 2.383-4.196 5.674-.081 3.291 1.6 5.817 3.91 5.875 2.31.057 4.114-2.383 4.196-5.674.082-3.291-1.599-5.817-3.91-5.875zm-.214 8.662c-1.194-.03-1.998-1.237-1.955-2.938.042-1.7.904-2.866 2.098-2.836 1.193.029 1.997 1.236 1.955 2.937-.043 1.7-.905 2.866-2.098 2.837z" />
      </g>
      <ellipse
        cx={612.584}
        cy={660.967}
        rx={21.401}
        ry={30.489}
        transform="rotate(1.421 612.584 660.967)"
        fill="#A0AEC0"
      />
      <path
        d="M618.877 629.235c-3.423-.085-9.622 1.596-11.064 2.172l3.622 1.924c1.218.235 3.65.825 3.637 1.314-.015.611 8.083-5.304 3.805-5.41zm4.626 60.055c-3.115 1.423-9.512 2.135-11.063 2.172l1.466-2.396c1.028-.693 3.032-2.192 2.829-2.637-.254-.556 10.661 1.082 6.768 2.861z"
        fill="#A0AEC0"
      />
      <ellipse
        cx={618.731}
        cy={659.729}
        rx={21.401}
        ry={30.489}
        transform="rotate(1.421 618.731 659.729)"
        fill="#CBD5E0"
      />
      <g filter="url(#prefix__filter80_d)" fill="#718096">
        <path d="M619.258 640.572c-7.318-.182-13.717 8.471-13.976 18.896-.152 6.132 1.859 11.742 5.021 15.372l-.003.146.137.004c2.193 2.45 4.914 3.97 7.866 4.044 2.953.073 5.746-1.311 8.057-3.649l.138.003.004-.146c3.338-3.469 5.625-8.97 5.777-15.104.259-10.425-5.704-19.385-13.021-19.566zm-6.108 32.42c.231-1.277.759-2.411 1.498-3.216.738-.806 1.643-1.233 2.565-1.213l2.699.067c.922.026 1.804.498 2.501 1.339.698.84 1.169 2 1.337 3.286-1.609 1.263-3.44 1.98-5.351 1.932-1.912-.047-3.704-.853-5.249-2.195zm12.934-2.153c-.471-1.759-1.299-3.272-2.38-4.349-1.081-1.077-2.367-1.67-3.696-1.706l-2.7-.067c-1.33-.03-2.643.498-3.776 1.52s-2.035 2.492-2.593 4.226c-1.911-2.855-3.061-6.744-2.957-10.928.207-8.341 5.326-15.262 11.18-15.117 5.855.145 10.624 7.312 10.418 15.653-.104 4.184-1.446 8.011-3.496 10.768z" />
        <path d="M619.067 648.264c-3.078-.076-5.482 3.174-5.59 7.558-.109 4.385 2.13 7.75 5.208 7.827 3.078.076 5.482-3.174 5.591-7.559.108-4.384-2.131-7.75-5.209-7.826zm-.286 11.539c-1.591-.04-2.661-1.648-2.605-3.914.057-2.265 1.205-3.818 2.795-3.779 1.591.04 2.661 1.648 2.605 3.913-.056 2.266-1.205 3.819-2.795 3.78z" />
      </g>
      <defs>
        <filter
          id="prefix__filter0_i"
          x={1008.88}
          y={211.284}
          width={168.168}
          height={72.758}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={3} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter1_f"
          x={999.394}
          y={166.274}
          width={149.883}
          height={123.413}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={15} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter2_d"
          x={1010.47}
          y={151.639}
          width={164.972}
          height={78.817}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter3_i"
          x={1041.18}
          y={159.923}
          width={103.551}
          height={46.249}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter4_i"
          x={1028.17}
          y={155.307}
          width={129.627}
          height={54.361}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter5_i"
          x={1041.02}
          y={160.199}
          width={103.946}
          height={45.578}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter6_i"
          x={1050.79}
          y={163.256}
          width={86.825}
          height={39.464}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter7_i"
          x={1071.59}
          y={172.428}
          width={42.801}
          height={19.12}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter8_f"
          x={1075.04}
          y={238.996}
          width={30}
          height={46}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter9_f"
          x={1011.04}
          y={220.996}
          width={30}
          height={45}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter10_di"
          x={682.923}
          y={234.229}
          width={346.877}
          height={203.717}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter11_i"
          x={944.176}
          y={274.362}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter12_f"
          x={695.765}
          y={244.334}
          width={322.909}
          height={182.353}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter13_di"
          x={747.4}
          y={252.334}
          width={346.877}
          height={203.717}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter14_i"
          x={874.201}
          y={367.302}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter15_f"
          x={760.243}
          y={262.439}
          width={322.909}
          height={182.353}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter16_i"
          x={585.754}
          y={385.211}
          width={248.247}
          height={105.5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={3.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter17_f"
          x={569.042}
          y={314.996}
          width={210.5}
          height={159.316}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={20} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter18_d"
          x={592.874}
          y={297.163}
          width={234.006}
          height={106.825}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter19_di"
          x={593.042}
          y={280.996}
          width={234}
          height={119}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values="0 0 0 0 0.352941 0 0 0 0 0.403922 0 0 0 0 0.847059 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter20_di"
          x={613.447}
          y={289.392}
          width={192.862}
          height={102.368}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values="0 0 0 0 0.352941 0 0 0 0 0.403922 0 0 0 0 0.847059 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter21_i"
          x={678.694}
          y={327.735}
          width={62.368}
          height={29.681}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter22_d"
          x={592.874}
          y={297.163}
          width={234.006}
          height={106.825}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter23_f"
          x={510.671}
          y={312.844}
          width={61.578}
          height={26.114}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter24_f"
          x={889.768}
          y={528.073}
          width={62.801}
          height={26.114}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter25_f"
          x={614.042}
          y={423.996}
          width={30}
          height={48}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter26_f"
          x={501.997}
          y={448.003}
          width={119.318}
          height={70.115}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter27_di"
          x={504.587}
          y={440.747}
          width={125.005}
          height={84.353}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter28_di"
          x={289.556}
          y={347.841}
          width={498.224}
          height={299.519}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter29_i"
          x={705.015}
          y={587.447}
          width={20.148}
          height={24.148}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter30_f"
          x={223.048}
          y={312.977}
          width={557.182}
          height={326.316}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter31_di"
          x={148.134}
          y={354.918}
          width={158.227}
          height={102.669}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter32_i"
          x={266.387}
          y={368.967}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter33_f"
          x={97.709}
          y={362.175}
          width={200.375}
          height={114.801}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter34_di"
          x={73.616}
          y={416.883}
          width={346.877}
          height={203.717}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter35_i"
          x={290.845}
          y={481.473}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter36_f"
          x={86.458}
          y={426.988}
          width={322.909}
          height={182.353}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter37_di"
          x={381.976}
          y={488.214}
          width={159.181}
          height={103.194}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter38_i"
          x={503.629}
          y={501.039}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter39_f"
          x={209.97}
          y={492.808}
          width={327.739}
          height={185.016}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter40_di"
          x={294.959}
          y={544.064}
          width={346.877}
          height={203.717}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter41_i"
          x={414.548}
          y={662.808}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter42_f"
          x={307.802}
          y={554.169}
          width={322.909}
          height={182.353}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter43_di"
          x={638.784}
          y={627.624}
          width={140.837}
          height={93.082}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="prefix__filter44_i"
          x={696.846}
          y={664.908}
          width={14.675}
          height={18.675}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter45_f"
          x={585.328}
          y={634.88}
          width={186.015}
          height={106.884}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter46_i"
          x={72.138}
          y={437.993}
          width={128.128}
          height={56.387}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter47_i"
          x={80.975}
          y={412.271}
          width={110.455}
          height={72.429}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.784314 0 0 0 0 0.827451 0 0 0 0 0.870588 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter48_f"
          x={58.648}
          y={378.427}
          width={155.109}
          height={120.395}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={20} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter49_d"
          x={70.975}
          y={392.549}
          width={130.455}
          height={64.813}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter50_i"
          x={96.754}
          y={398.861}
          width={78.896}
          height={35.19}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter51_i"
          x={551.513}
          y={716.813}
          width={128.128}
          height={56.387}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter52_i"
          x={560.349}
          y={691.091}
          width={110.455}
          height={72.429}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.784314 0 0 0 0 0.827451 0 0 0 0 0.870588 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter53_f"
          x={538.022}
          y={657.247}
          width={155.109}
          height={120.395}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={20} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter54_d"
          x={550.349}
          y={671.368}
          width={130.455}
          height={64.813}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter55_i"
          x={576.128}
          y={677.68}
          width={78.896}
          height={35.19}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter56_i"
          x={243.344}
          y={739.718}
          width={89.271}
          height={40.5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter57_i"
          x={249.5}
          y={720.886}
          width={76.958}
          height={51.374}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.784314 0 0 0 0 0.827451 0 0 0 0 0.870588 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter58_f"
          x={221.813}
          y={686.085}
          width={132.331}
          height={108.145}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={20} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter59_d"
          x={239.5}
          y={708.055}
          width={96.958}
          height={51.223}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter60_i"
          x={260.495}
          y={712.452}
          width={54.97}
          height={25.428}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter61_i"
          x={22}
          y={613.76}
          width={89.271}
          height={40.5}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter62_i"
          x={28.157}
          y={594.928}
          width={76.958}
          height={51.374}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.784314 0 0 0 0 0.827451 0 0 0 0 0.870588 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter63_f"
          x={0.47}
          y={560.127}
          width={132.331}
          height={108.145}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={20} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter64_d"
          x={18.157}
          y={582.097}
          width={96.958}
          height={51.223}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter65_i"
          x={39.151}
          y={586.494}
          width={54.97}
          height={25.428}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter66_i"
          x={311.826}
          y={577.403}
          width={128.128}
          height={56.387}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter67_i"
          x={320.662}
          y={551.681}
          width={110.455}
          height={72.429}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-3} />
          <feGaussianBlur stdDeviation={7.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0.784314 0 0 0 0 0.827451 0 0 0 0 0.870588 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter68_f"
          x={298.335}
          y={517.837}
          width={155.109}
          height={120.395}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={20} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter69_d"
          x={310.662}
          y={531.958}
          width={130.455}
          height={64.813}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter70_i"
          x={336.441}
          y={538.271}
          width={78.896}
          height={35.19}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={1.5} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="prefix__filter71_f"
          x={49.241}
          y={588.549}
          width={36.827}
          height={18.892}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={3.5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter72_f"
          x={107.116}
          y={402.115}
          width={62.801}
          height={26.114}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter73_f"
          x={349.519}
          y={542.748}
          width={54.241}
          height={26.114}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter74_f"
          x={587.983}
          y={682.158}
          width={54.241}
          height={26.114}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter75_f"
          x={270.585}
          y={714.507}
          width={36.827}
          height={18.892}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={3.5} result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="prefix__filter76_d"
          x={364.118}
          y={500.827}
          width={29.952}
          height={41.132}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter77_d"
          x={124.431}
          y={360.194}
          width={29.952}
          height={41.132}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter78_d"
          x={58.465}
          y={556.616}
          width={22.981}
          height={31.373}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter79_d"
          x={278.586}
          y={682.574}
          width={22.981}
          height={31.373}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="prefix__filter80_d"
          x={603.805}
          y={640.237}
          width={29.952}
          height={41.132}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient
          id="prefix__paint0_linear"
          x1={1093.25}
          y1={144.913}
          x2={1092.99}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#95BF46" stopOpacity={0.5} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={375.146}
          y1={164.479}
          x2={1153.52}
          y2={609.612}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.39} />
          <stop offset={0.516} stopColor="#B4BFCC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.4} />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear"
          x1={465.641}
          y1={256.808}
          x2={1091.71}
          y2={609.99}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.43} />
          <stop offset={0.385} stopColor="#E0E7EF" />
          <stop offset={0.872} stopColor="#fff" stopOpacity={0.29} />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear"
          x1={264.002}
          y1={190.732}
          x2={1042.37}
          y2={635.866}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0} />
          <stop offset={0.553} stopColor="#B4BFCC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </linearGradient>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M1061.46 81.934h61.145v69.705h-61.145z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HomeIllustration
